import { State } from "reducers";
import { createSelector } from "reselect";

export const getRolesState =
    (state: State) => state.roles;

export const getRoles =
    createSelector(
        getRolesState,
        state => state.data
    );

export const getLoadingRoles =
    createSelector(
        getRolesState,
        state => state.loading
    );

export const getRolesError =
    createSelector(
        getRolesState,
        state => state.error
    );
